import * as React from 'react';
import { connect } from 'react-redux';

type NoEventsProps = any;

export class NoEventsComponent extends React.Component<NoEventsProps, null> {
    constructor(props: NoEventsProps) {
        super(props);
    }

    render() {
        return (
            <div className="calendar-container-results-message">
                <p>No events occurring this month for the selected category.</p>
            </div> 
        )
    }
}

export default connect(null, null)(NoEventsComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/no-events.tsx